export const OPEN_EDIT_VERSION_MODEL = "OPEN_EDIT_VERSION_MODEL";
export const CLOSE_EDIT_VERSION_MODEL = "CLOSE_EDIT_VERSION_MODEL";
export const SET_VERSION_PENDING = "SET_VERSION_PENDING";
export const SET_VERSION = "SET_VERSION";
export const UPDATE_VERSION_PENDING = "UPDATE_VERSION_PENDING";
export const UPDATE_VERSION_SUCCESS = "UPDATE_VERSION_SUCCESS";
export const UPDATE_VERSION_ERROR = "UPDATE_VERSION_ERROR";
export const CLEAR_UPDATE_VERSION_ERROR = "CLEAR_UPDATE_VERSION_ERROR";
export const SET_MAINT_FAMILY_PENDING = "SET_MAINT_FAMILY_PENDING";
export const SET_MAINT_FAMILY_LIST = "SET_MAINT_FAMILY_LIST";
export const OPEN_CREATE_PUMPFAMILY_MODEL = "OPEN_CREATE_PUMPFAMILY_MODEL";
export const CLOSE_CREATE_PUMPFAMILY_MODEL = "CLOSE_CREATE_PUMPFAMILY_MODEL";
export const CLEAR_PUMPFAMILY_ERROR = "CLEAR_PUMPFAMILY_ERROR";
export const CREATE_PUMPFAMILY_ERROR = "CREATE_PUMPFAMILY_ERROR";
export const CREATE_PUMPFAMILY_PENDING = "CREATE_PUMPFAMILY_PENDING";
export const CREATE_PUMPFAMILY_SUCCESS = "CREATE_PUMPFAMILY_SUCCESS";
export const SET_LOCK_EDITING = "SET_LOCK_EDITING";
export const OPEN_EDIT_PUMPFAMILY_MODEL = "OPEN_EDIT_PUMPFAMILY_MODEL";
export const CLOSE_EDIT_PUMPFAMILY_MODEL = "CLOSE_EDIT_PUMPFAMILY_MODEL";
export const SET_PUMPFAMILY_DETAILS = "SET_PUMPFAMILY_DETAILS";
export const CLEAR_UPDATE_PUMPFAMILY_ERROR = "CLEAR_UPDATE_PUMPFAMILY_ERROR";
export const UPDATE_PUMPFAMILY_PENDING = "UPDATE_PUMPFAMILY_PENDING";
export const UPDATE_PUMPFAMILY_SUCCESS = "UPDATE_PUMPFAMILY_SUCCESS";
export const UPDATE_PUMPFAMILY_ERROR = "UPDATE_PUMPFAMILY_ERROR";
export const SET_MAINT_PUMPDATA_PENDING = "SET_MAINT_PUMPDATA_PENDING";
export const SET_MAINT_PUMPDATA_LIST = "SET_MAINT_PUMPDATA_LIST";
export const SET_ACTIVE_PUMP_DATA = "SET_ACTIVE_PUMP_DATA";
export const UPDATE_PUMP_ERROR = "UPDATE_PUMP_ERROR";
export const CREATE_PUMP_ERROR = "CREATE_PUMP_ERROR";
export const CLEAR_CREATE_PUMP_ERROR = "CLEAR_CREATE_PUMP_ERROR";
export const CREATE_PUMP_PENDING = "CREATE_PUMP_PENDING";
export const CREATE_PUMP_SUCCESS = "CREATE_PUMP_SUCCESS";
export const CLEAR_PUMP_DETAILS = "CLEAR_PUMP_DETAILS";
export const CLEAR_UPDATE_PUMP_ERROR = "CLEAR_UPDATE_PUMP_ERROR";
export const UPDATE_PUMP_PENDING = "UPDATE_PUMP_PENDING";
export const UPDATE_PUMP_SUCCESS = "UPDATE_PUMP_SUCCESS";
export const CLOSE_EDIT_PUMP_MODEL = "CLOSE_EDIT_PUMP_MODEL";
export const CLOSE_ADD_PUMP_MODEL = "CLOSE_ADD_PUMP_MODEL";
export const SET_MAINT_PIPEMATERIAL_PENDING = "SET_MAINT_PIPEMATERIAL_PENDING";
export const SET_MAINT_PIPEMATERIAL_LIST = "SET_MAINT_PIPEMATERIAL_LIST";
export const OPEN_CREATE_PIPEMATERIAL_MODEL = "OPEN_CREATE_PIPEMATERIAL_MODEL";
export const CLOSE_CREATE_PIPEMATERIAL_MODEL = "CLOSE_CREATE_PIPEMATERIAL_MODEL";
export const CLEAR_PIPEMATERIAL_ERROR = "CLEAR_PIPEMATERIAL_ERROR";
export const CREATE_PIPEMATERIAL_ERROR = "CREATE_PIPEMATERIAL_ERROR";
export const CREATE_PIPEMATERIAL_PENDING = "CREATE_PIPEMATERIAL_PENDING";
export const CREATE_PIPEMATERIAL_SUCCESS = "CREATE_PIPEMATERIAL_SUCCESS";
export const OPEN_EDIT_PIPEMATERIAL_MODEL = "OPEN_EDIT_PIPEMATERIAL_MODEL";
export const CLOSE_EDIT_PIPEMATERIAL_MODEL = "CLOSE_EDIT_PIPEMATERIAL_MODEL";
export const SET_PIPEMATERIAL_DETAILS = "SET_PIPEMATERIAL_DETAILS";
export const CLEAR_UPDATE_PIPEMATERIAL_ERROR = "CLEAR_UPDATE_PIPEMATERIAL_ERROR";
export const UPDATE_PIPEMATERIAL_PENDING = "UPDATE_PIPEMATERIAL_PENDING";
export const UPDATE_PIPEMATERIAL_SUCCESS = "UPDATE_PIPEMATERIAL_SUCCESS";
export const UPDATE_PIPEMATERIAL_ERROR = "UPDATE_PIPEMATERIAL_ERROR";
export const SET_MAINT_PIPEELEMENTFAMILY_PENDING = "SET_MAINT_PIPEELEMENTFAMILY_PENDING";
export const SET_MAINT_PIPEELEMENTFAMILY_LIST = "SET_MAINT_PIPEELEMENTFAMILY_LIST";
export const OPEN_CREATE_PIPEELEMENTFAMILY_MODEL = "OPEN_CREATE_PIPEELEMENTFAMILY_MODEL";
export const CLOSE_CREATE_PIPEELEMENTFAMILY_MODEL = "CLOSE_CREATE_PIPEELEMENTFAMILY_MODEL";
export const CLEAR_PIPEELEMENTFAMILY_ERROR = "CLEAR_PIPEELEMENTFAMILY_ERROR";
export const CREATE_PIPEELEMENTFAMILY_ERROR = "CREATE_PIPEELEMENTFAMILY_ERROR";
export const CREATE_PIPEELEMENTFAMILY_PENDING = "CREATE_PIPEELEMENTFAMILY_PENDING";
export const CREATE_PIPEELEMENTFAMILY_SUCCESS = "CREATE_PIPEELEMENTFAMILY_SUCCESS";
export const OPEN_EDIT_PIPEELEMENTFAMILY_MODEL = "OPEN_EDIT_PIPEELEMENTFAMILY_MODEL";
export const CLOSE_EDIT_PIPEELEMENTFAMILY_MODEL = "CLOSE_EDIT_PIPEELEMENTFAMILY_MODEL";
export const SET_PIPEELEMENTFAMILY_DETAILS = "SET_PIPEELEMENTFAMILY_DETAILS";
export const CLEAR_UPDATE_PIPEELEMENTFAMILY_ERROR = "CLEAR_UPDATE_PIPEELEMENTFAMILY_ERROR";
export const UPDATE_PIPEELEMENTFAMILY_PENDING = "UPDATE_PIPEELEMENTFAMILY_PENDING";
export const UPDATE_PIPEELEMENTFAMILY_SUCCESS = "UPDATE_PIPEELEMENTFAMILY_SUCCESS";
export const UPDATE_PIPEELEMENTFAMILY_ERROR = "UPDATE_PIPEELEMENTFAMILY_ERROR";
export const SET_MAINT_PIPEELEMENT_PENDING = "SET_MAINT_PIPEELEMENT_PENDING";
export const SET_MAINT_PIPEELEMENT_LIST = "SET_MAINT_PIPEELEMENT_LIST";
export const OPEN_CREATE_PIPEELEMENT_MODEL = "OPEN_CREATE_PIPEELEMENT_MODEL";
export const CLOSE_CREATE_PIPEELEMENT_MODEL = "CLOSE_CREATE_PIPEELEMENT_MODEL";
export const CLEAR_PIPEELEMENT_ERROR = "CLEAR_PIPEELEMENT_ERROR";
export const CREATE_PIPEELEMENT_ERROR = "CREATE_PIPEELEMENT_ERROR";
export const CREATE_PIPEELEMENT_PENDING = "CREATE_PIPEELEMENT_PENDING";
export const CREATE_PIPEELEMENT_SUCCESS = "CREATE_PIPEELEMENT_SUCCESS";
export const OPEN_EDIT_PIPEELEMENT_MODEL = "OPEN_EDIT_PIPEELEMENT_MODEL";
export const CLOSE_EDIT_PIPEELEMENT_MODEL = "CLOSE_EDIT_PIPEELEMENT_MODEL";
export const SET_PIPEELEMENT_DETAILS = "SET_PIPEELEMENT_DETAILS";
export const CLEAR_UPDATE_PIPEELEMENT_ERROR = "CLEAR_UPDATE_PIPEELEMENT_ERROR";
export const UPDATE_PIPEELEMENT_PENDING = "UPDATE_PIPEELEMENT_PENDING";
export const UPDATE_PIPEELEMENT_SUCCESS = "UPDATE_PIPEELEMENT_SUCCESS";
export const UPDATE_PIPEELEMENT_ERROR = "UPDATE_PIPEELEMENT_ERROR";
export const SET_ACTIVE_PIPEELEMENT = "SET_ACTIVE_PIPEELEMENT";
export const SET_ACCESS_PENDING = "SET_ACCESS_PENDING";
export const SET_ACCESS_STATUS = "SET_ACCESS_STATUS";
export const SET_LOCKVALUE_PENDING = "SET_LOCKVALUE_PENDING";
// export const SET_LOCKSCREEN = "SET_LOCKSCREEN";
export const OPEN_RELEASE_MODEL = "OPEN_RELEASE_MODEL";
export const CLOSE_RELEASE_MODEL = "CLOSE_RELEASE_MODEL";
export const SET_REFRESH_LOG_PENDING = "SET_REFRESH_LOG_PENDING";
export const SET_REFRESH_LOG = "SET_REFRESH_LOG";
export const OPEN_RELEASE_COMMENTS_MODEL = "OPEN_RELEASE_COMMENTS_MODEL";
export const CLOSE_RELEASE_COMMENTS_MODEL = "CLOSE_RELEASE_COMMENTS_MODEL";
export const SET_LOCKSCREEN = "SET_LOCKSCREEN";
export const SET_RELEASE_BOOLEAN = "SET_RELEASE_BOOLEAN";
export const SET_RELEASE_ERROR = "SET_RELEASE_ERROR";
export const CLEAR_ACCESS_STATUS_PENDING = "CLEAR_ACCESS_STATUS_PENDING";
export const CLEAR_ACCESS_STATUS_SUCCESS = "CLEAR_ACCESS_STATUS_SUCCESS";
export const CLEAR_OVERRIDE_PENDING = "CLEAR_OVERRIDE_PENDING";
export const CLEAR_OVERRIDE_SUCCESS = "CLEAR_OVERRIDE_SUCCESS";
export const SET_LOCK_ERROR = "SET_LOCK_ERROR";
export const SET_AVAILABLE_VALUES = "SET_AVAILABLE_VALUES";
export const SET_RELEASEDB_PENDING = "SET_RELEASEDB_PENDING";
export const SET_RELEASEDB = "SET_RELEASEDB";